interface Located {
  location: { lat: number; lon: number };
}

/** South-west and north-east corners as [lng, lat] pairs, the shape mapbox takes. */
export type LngLatBoundsTuple = [[number, number], [number, number]];

/** The box around every pub on the crawl, or null when there are none to frame. */
export const getCrawlBounds = (pubs: Located[]): LngLatBoundsTuple | null => {
  if (pubs.length === 0) return null;
  const lngs = pubs.map(pub => pub.location.lon);
  const lats = pubs.map(pub => pub.location.lat);
  return [
    [Math.min(...lngs), Math.min(...lats)],
    [Math.max(...lngs), Math.max(...lats)],
  ];
};
